export default __webpack_public_path__ + "static/media/linkedin.5609bab2.svg";